<script>
import { FormatPercentSalesKpi } from "../../utils";
export default {
  name: "HyperlinkKpiSales",
  functional: true,
  props: {
    row: Object,
    column: String,
    mes: Number,
    openDetail: Function
  },
  render: function (createElement, context) {
    const val = Number(context.props.row[context.props.column]);
    let classs = "red";

    if (val <= 70) {
      classs = "red";
    } else if (val >= 90) {
      classs = "green";
    } else if (val >= 71 && val <= 81) {
      classs = "golden";
    }

    const MothValue = function (val) {
      // if (val > 0) {
      return FormatPercentSalesKpi(val);
      // } else {
      //   return "";
      // }
    };

    return createElement(
      "a",
      {
        attrs: {
          name: "",
          href: "#",
          class: classs
        },
        on: {
          click: () => {
            const { mes, row, openDetail } = context.props;
            openDetail(mes, row);
          }
        }
      },
      MothValue(val)
    );
  }
};
</script>
<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.golden {
  color: goldenrod;
}
</style>
